module.exports = __webpack_public_path__ + "img/rank-diamond.f79094de.png";